var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm-text-copy",class:{
    'copied': _vm.justCopied
  },on:{"click":function($event){$event.stopPropagation();return _vm.copyText.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('include-svg',{attrs:{"name":'icon-copy'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }